/**
 * 政府端 — 在途车辆列表
 */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchOrders } from '@/api/transit';
import { Empty, Loading, PageHeader, AlertLevelTag, OrderStatusTag } from '@/components/common';
import type { TransitOrder } from '@/types';
import { fmtTime } from '@/utils/format';

export default function GovVehicles() {
  const [orders, setOrders] = useState<TransitOrder[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders({ page_size: 100 }).then((d) => {
      setOrders(d.list);
      setLoading(false);
    });
  }, []);

  if (loading) return <Loading />;

  return (
    <div>
      <PageHeader title="在途车辆" sub="全部运输单车辆位置与状态" />
      <div className="card">
        {orders.length === 0 ? (
          <Empty />
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>运输单号</th>
                <th>车牌</th>
                <th>路线</th>
                <th>状态</th>
                <th>告警级别</th>
                <th>最新位置</th>
                <th>最近上报</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id}>
                  <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{o.transit_no}</td>
                  <td>
                    <strong>{o.vehicle?.plate_no ?? `#${o.vehicle_id}`}</strong>
                  </td>
                  <td>
                    {o.origin_city} → {o.destination_city}
                  </td>
                  <td>
                    <OrderStatusTag status={o.status} />
                  </td>
                  <td>{o.alert_level > 0 ? <AlertLevelTag level={o.alert_level} /> : <span style={{ color: 'var(--color-green)' }}>正常</span>}</td>
                  <td style={{ fontFamily: 'monospace', fontSize: 12 }}>
                    {o.last_lng.toFixed(4)}, {o.last_lat.toFixed(4)}
                  </td>
                  <td style={{ fontSize: 12, color: 'var(--color-ink-secondary)' }}>{fmtTime(o.last_gps_time)}</td>
                  <td>
                    <Link className="btn btn-sm btn-ghost" to={`/gov/vehicles/${o.id}`}>
                      轨迹详情
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
